import angular from 'angular';
import moment from 'moment-timezone';

module.exports = angular.module('common.filters.tz_format', [])
.filter('tzFormat', function() {
  return function(string, format, timezone) {
    return moment.tz(string, timezone).format(format);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/tz_format.js
 **/